import styles from './MediaWrapper.scss';

import cx from 'classnames';
import React from 'react';

import { FadeToastUp } from 'src/components/Animation/FadeToastUp/FadeToastUp';
import { EnhancedMedia } from 'src/components/EnhancedMedia/EnhancedMedia';

import { IEntryProp } from '../../IEntries';

export const MediaWrapper: React.FC<IEntryProp> = ({
  entry, className, backgroundColor, first, ...props
}) => {
  if (!entry || !entry.fields) return null;

  const { topic, isMediaMasked } = entry.fields;

  const content = (
    <div
      className={cx(className, styles.mediaMaskWrapper, {
        [styles.mediaMaskWrapperMask]: isMediaMasked,
      })}
      {...props}
    >
      <EnhancedMedia
        className={styles.mediaWrapper}
        style={{ backgroundColor }}
        preferHeight
        entry={topic}
      />
    </div>
  );

  if (first) return <FadeToastUp>{content}</FadeToastUp>;

  return content;
};
